export default {
  ctaText: "Adjust production",
  sidePanelSubtitle: " This information can be used later to update production.",
  sidePanelTitle: "Hurray, there have been sales!",
  tagLabel: "Middle of the day"
};
